import { render } from "./Sentence.vue?vue&type=template&id=fabab48c&scoped=true"
import script from "./Sentence.vue?vue&type=script&lang=js"
export * from "./Sentence.vue?vue&type=script&lang=js"

import "./Sentence.vue?vue&type=style&index=0&id=fabab48c&scoped=true&lang=css"

import exportComponent from "D:\\project\\survey-slp-house\\survey-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fabab48c"]])

export default __exports__